<template>
  <div
    class="main-content-filter">
    <el-row>
      <el-col :span="20">
        <el-input
          v-debounce:1s="defaultSearchFunction"
          placeholder="Buscar..."
          suffix-icon="icon-search"/>
      </el-col>
      <el-col :span="4">
        <div class="ms-dropdown">
          <el-button
            :class="{active: isFilterActive === true}"
            @click="onFilter">
            <i class="icon-sliders"/>
            Filtros
          </el-button>
          <transition
            name="ms-dropdown"
            enter-active-class="animated fadeInDown"
            leave-active-class="animated fadeOutUp">
            <div
              v-if="clickFilter"
              class="ms-dropdown-menu">
              <div class="close">
                <el-button
                  icon="icon-x"
                  @click="onFilter"/>
              </div>
              <div
                v-for="(filter,index) in filters"
                :key="index"
                class="content-filter">
                <slot
                  :name="filter.property"
                  :filter="filter"
                  :getFilterValue="filterApply"
                >
                  <component
                    :is="filterComponent(filter)"
                    v-bind="{propsFilter:filter.props, propertyFilter: filter.property, typeFilter:filter.type}"
                    @getFilterValue="(val)=>filterApply(filter, val)"/>
                </slot>
              </div>
              <div
                class="cleanButton">
                <el-button
                  @click="cleanFilters">
                  Limpiar Filtros
                </el-button>
              </div>
            </div>
          </transition>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import MsSelect from '@/components/_shared/catalogForm/ms-select'
import MsDatePicker from '@/components/_shared/catalogForm/ms-datepicker'
import MsRadio from '@/components/_shared/catalogForm/ms-radio-button'
import moment from 'moment'
export default {
  name: 'MsFormFilter',
  components: {
    MsSelect,
    MsDatePicker,
    MsRadio
  },
  props: {
    filters: {
      type: Array,
      default: null
    },
    defaultSearch: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isActiveFilter: false,
      clickFilter: false
    }
  },
  computed: {
    isFilterActive () {
      if (Object.keys(this.$route.query).length > 0) {
        if (this.$route.query.sort || this.$route.query.page) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    }
  },
  mounted () {
    let length = Object.keys(this.$route.query).length
    if (length > 3) {
      return true
    } else if (length === 2) {
      if (this.$route.query.hasOwnProperty('page') && this.$route.query.hasOwnProperty('sort')) {
        return false
      }
    } else if (length === 1) {
      if (this.$route.query.hasOwnProperty('page') || this.$route.query.hasOwnProperty('sort')) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    onFilter () {
      this.clickFilter = !this.clickFilter
    },
    filterComponent (filter) {
      switch (filter.type) {
        case 'date':
          return 'ms-date-picker'
        case 'boolean':
          return 'ms-radio'
        case 'enum':
          return 'ms-select'
        default:
          return 'ms-radio'
      }
    },
    filterApply (filter, val) {
      let valueFilter = {}
      let _query = {}
      _query = filter.queryFunction ? filter.queryFunction(val) : this.defaultQueryFunction(filter, val)
      if (filter.type === 'date') {
        valueFilter = this.getDateValue(filter, val)
      } else {
        valueFilter[filter.property] = val
      }
      _query = {..._query, ...valueFilter}
      this.executeFilter(_query)
    },
    defaultQueryFunction (filter, val) {
      let _defaultQuery = {}
      _defaultQuery[`filters[where][${filter.property}][eq]`] = val
      return _defaultQuery
    },
    defaultSearchFunction (val) {
      let _defaultQuery = {}
      if (val !== '') {
        _defaultQuery[`filters[where][${this.defaultSearch}][contains]`] = val
        this.executeFilter(_defaultQuery)
      } else {
        let query = {}
        if (this.$route.query.sort) { query.sort = this.$route.query.sort }
        if (this.$route.query.page) { query.page = this.$route.query.page }
        if (this.$route.query.search) { query.search = this.$route.query.search }
        this.$router.replace({query: query})
      }
    },
    executeFilter (queryValue) {
      let query = Object.assign({}, this.$route.query)
      this.$router.replace({query: {...query, ...queryValue}})
    },
    getDateValue (filter, val) {
      let objDate = {}
      if (!Array.isArray(val)) {
        objDate[filter.property] = val ? moment(val).format('YYYY-MM-DD') : null
        objDate.startDateFilter = null
        objDate.endDateFilter = null
      } else {
        objDate[filter.property + 'StartDate'] = moment(val[0]).format('YYYY-MM-DD')
        objDate[filter.property + 'EndDate'] = moment(val[1]).format('YYYY-MM-DD')
        objDate[filter.property] = null
      }
      return objDate
    },
    cleanFilters () {
      let query = {}
      if (this.$route.query.sort) { query.sort = this.$route.query.sort }
      if (this.$route.query.page) { query.page = this.$route.query.page }
      if (this.$route.query.search) { query.search = this.$route.query.search }
      this.$router.replace({query: query})
    }
  }
}
</script>

<style scoped lang="scss">
  .ms-dropdown {
    position: relative;
    .el-button{
      width: 100%;
    }
    .ms-dropdown-menu{
      min-height: 200px;
      min-width: 300px;
      position: absolute;
      background-color: #ffffff;
      box-shadow: 0px 0px 3px 1px;
      z-index: 1;
      right: 20%;
      top: 110%;
      .close{
        position: absolute;
        right: 0;
        top: 5px;
        display: flex;
        justify-content: flex-end;
        .el-button{
          width: 50px;
          margin-right: 10px;
          border: none;
          outline: none;
          font-size: 18px;
          text-align: center;
          padding: 12px;
        }
      }
      .content-filter{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin: 20px;
      }
    }
  }
  .active{
    border: 1px solid red;
    color: $primary;
  }
  .cleanButton{
    margin: 15px;
    .el-button{
      width: 100%;
      border-radius: 0;
      background-color: $primary;
      color: #ffffff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_shared/ms-form-filter.vue